<app-header />

<div class="content">
    <router-outlet />
</div>

<app-footer />
